// extracted by mini-css-extract-plugin
module.exports = {"item":"style_item__mwjpN","img-2":"style_img-2__gAgmw","img-4":"style_img-4__Gs5Jw"};